var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEmblem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "46px",
    viewBox: "0 0 53 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B6BF1F1F-FB37-4DB4-B9AA-E5A651299D2B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editing-profile---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/edit-resume",
    transform: "translate(-689.000000, -80.000000)",
    fill: "#0A9AFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(689.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 0 26.4998468 46 32.9806519 34.7501145 29.4530308 28.6271368 26.4998468 33.7536058 17.6372297 18.3698107 17.6394189 18.3698107 14.1117978 12.2463942 14.1100465 12.2463942 10.5824254 6.12297772 10.5846145 6.12297772 7.05699347 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "21.1669961 12.2463942 24.6946172 18.3698107 35.36242 18.3698107 32.9806081 22.5037202 36.5082292 28.6271368 45.9448454 12.2463942"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "14.1121043 0 17.6397253 6.12297772 22.8337391 6.12297772 42.4175746 6.12297772 49.4723789 6.12297772 53 0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmblem);
export default __webpack_public_path__ + "static/media/logo_emblem.8876141ea8e69527430e77e2ad6db0a2.svg";
export { ForwardRef as ReactComponent };